import * as TYPE from '../types/coverage';

export const setInitCoverageList = (payload) => ({
  type: TYPE.SET_INIT_COVERAGE_LIST,
  payload,
});

export const setCoverageList = (payload) => ({
  type: TYPE.SET_COVERAGE_LIST,
  payload,
});

export const setCoveragePlanType = (payload) => ({
  type: TYPE.SET_COVERAGE_PLAN_TYPE,
  payload,
});
export const setProduct = (payload) => ({
  type: TYPE.SET_PRODUCT,
  payload,
});

export const setUserFlowType = (payload) => ({
  type: TYPE.SET_USER_FLOW_TYPE,
  payload,
});

export const setErrorCode = (payload) => ({
  type: TYPE.SET_ERROR_CODE,
  payload,
});
